// contexts/OperatorContext.js
import React, { createContext, useContext, useState } from 'react';

const OperatorContext = createContext();

export const useOperator = () => {
  return useContext(OperatorContext);
};

export const OperatorProvider = ({ children }) => {
  const [Operator, setOperator] = useState({
    OperatorId: null,
    mobile: null,
    state: null,
    district: null,
  });

  const updateOperator = (OperatorData) => {
    setOperator(prev => ({ ...prev, ...OperatorData }));
  };

  const clearOperator = () => {
    setOperator({
      OperatorId: null,
      mobile: null,
      state: null,
      district: null,
      registrationStatus: null
    });
    localStorage.clear()
  };

  const value = {
    Operator,
    updateOperator,
    clearOperator
  };

  return (
    <OperatorContext.Provider value={value}>
      {children}
    </OperatorContext.Provider>
  );
};
